export const SET_ALL_AUDIO_ABBREVIATIONS = `SET_ALL_AUDIO_ABBREVIATIONS`;
export const CLEAR_AUDIO_ABBREVIATIONS = `CLEAR_AUDIO_ABBREVIATIONS`;
